import {
  TbCheck,
  TbChevronDown,
  TbChevronLeft,
  TbChevronRight,
  TbChevronUp,
  TbCloudDownload,
  TbCloudUpload,
  TbDeviceMobile,
  TbDotsVertical,
  TbDownload,
  TbFileDownload,
  TbFileUpload,
  TbFilter,
  TbHome,
  TbListCheck,
  TbMenu2,
  TbMinus,
  TbPlus,
  TbRefresh,
  TbShield,
  TbTrash,
  TbUpload,
  TbWallet,
  TbLockOpen,
  TbLogout2,
  TbExternalLink,
  TbArrowsMinimize,
  TbArrowsMaximize,
  TbAlertTriangle,
  TbCircleCheck,
  TbInfoCircle,
  TbCircleX,
  TbFileTypePdf,
  TbFileExport,
  TbTag,
  TbDeviceFloppy,
  TbMapPin,
  TbStack2,
  TbBackspace,
  TbWheelchair,
  TbEar,
  TbFlag,
  TbTool,
  TbCalendarMonth,
  TbCalendarEvent,
  TbGripVertical,
  TbGripHorizontal,
  TbClipboardText,
  TbFolderUp,
  TbPaperclip,
  TbPhoto,
  TbCircleFilled,
  TbEye,
  TbEyeOff,
  TbListDetails,
  TbSquarePlus,
  TbMap,
  TbMessage,
} from 'react-icons/tb';
import {
  LuArrowDown,
  LuArrowDownWideNarrow,
  LuArrowLeft,
  LuArrowRight,
  LuArrowUp,
  LuArrowUpNarrowWide,
  LuCreditCard,
  LuLayoutPanelLeft,
  LuListCheck,
  LuMessageSquareWarning,
  LuTriangleAlert,
  LuUserRound,
  LuUsersRound,
  LuX,
  LuUserPlus,
  LuArrowUpLeft,
  LuArrowDownLeft,
  LuArrowDownRight,
  LuArrowUpRight,
  LuMoon,
  LuSun,
} from 'react-icons/lu';
import { FiEdit2, FiList, FiSettings } from 'react-icons/fi';
import { MdCheckBoxOutlineBlank, MdOutlineCheckBox } from 'react-icons/md';

export const IconPlus = TbPlus;

export const IconMinus = TbMinus;

export const IconXmark = LuX;

export const IconXMarkCircle = TbCircleX;

export const IconEdit = FiEdit2;

export const IconFilter = TbFilter;

export const IconCheck = TbCheck;

export const IconCheckCircle = TbCircleCheck;

export const IconInfoCircle = TbInfoCircle;

export const IconExclamationTriangle = TbAlertTriangle;

export const IconSortAsc = LuArrowUpNarrowWide;

export const IconSortDesc = LuArrowDownWideNarrow;

export const IconRefresh = TbRefresh;

export const IconMoreVert = TbDotsVertical;

export const IconSettings = FiSettings;

export const IconUnlock = TbLockOpen;

export const IconExternalLink = TbExternalLink;

export const IconPDF = TbFileTypePdf;

export const IconExport = TbFileExport;

export const IconSun = LuSun;

export const IconMoon = LuMoon;

// LISTS
export const IconList = FiList;

export const IconTaskList = TbListCheck;

export const IconListSelect = LuListCheck;

// ARROWS AND CHEVRONS
export const IconChevronRight = TbChevronRight;

export const IconChevronLeft = TbChevronLeft;

export const IconChevronUp = TbChevronUp;

export const IconChevronDown = TbChevronDown;

export const IconArrowUp = LuArrowUp;

export const IconArrowDown = LuArrowDown;

export const IconArrowRight = LuArrowRight;

export const IconArrowLeft = LuArrowLeft;

export const IconArrowUpRight = LuArrowUpRight;

export const IconArrowDownRight = LuArrowDownRight;

export const IconArrowDownLeft = LuArrowDownLeft;

export const IconArrowUpLeft = LuArrowUpLeft;

export const IconArrowsOut = TbArrowsMaximize;

export const IconArrowsIn = TbArrowsMinimize;

export const IconCheckboxEmpty = MdCheckBoxOutlineBlank;

export const IconCheckboxChecked = MdOutlineCheckBox;

//TRASH
export const IconTrash = TbTrash;

// WARNINGS
export const IconWarningMessage = LuMessageSquareWarning;

export const IconWarningTriangle = LuTriangleAlert;

// DOWNLOAD & UPLOADS
export const IconDownload = TbDownload;

export const IconCloudDownload = TbCloudDownload;

export const IconFileDownload = TbFileDownload;

export const IconUpload = TbUpload;

export const IconCloudUpload = TbCloudUpload;

export const IconFileUpload = TbFileUpload;

// USER
export const IconUser = LuUserRound;

export const IconUserGroup = LuUsersRound;

export const IconSmartphoneDevice = TbDeviceMobile;

export const IconCreditCard = LuCreditCard;

export const IconWallet = TbWallet;

export const IconHome = TbHome;

export const IconDashboard = LuLayoutPanelLeft;

export const IconHamburger = TbMenu2;

export const IconUserPlus = LuUserPlus;

export const IconAdministrators = TbShield;

export const IconShield = TbShield;

export const IconTag = TbTag;

export const IconLogout = TbLogout2;

export const IconSave = TbDeviceFloppy;

export const IconMapPin = TbMapPin;

export const IconMap = TbMap;

export const IconStack = TbStack2;

export const IconBackspace = TbBackspace;

export const IconAccessible = TbWheelchair;

export const IconHearing = TbEar;

export const IconFlag = TbFlag;

export const IconTool = TbTool;

export const IconCalendarMonth = TbCalendarMonth;

export const IconCalendarEvent = TbCalendarEvent;

export const IconDragVertical = TbGripVertical;

export const IconDragHandle = TbGripHorizontal;

export const IconAssignment = TbClipboardText;

export const IconFolderUpload = TbFolderUp;

export const IconAttachment = TbPaperclip;

export const IconImage = TbPhoto;

export const IconCircleFilled = TbCircleFilled;

export const IconEye = TbEye;

export const IconEyeOff = TbEyeOff;

export const IconListDetails = TbListDetails;

export const IconSquarePlus = TbSquarePlus;

export const IconMessage = TbMessage;
